import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

/**
 * MessageFlow — BPMN 2.0 dashed line connecting elements across different Pools.
 *
 * Visual: dashed stroke, circle start marker, open arrow end marker.
 */

class MessageFlowView extends PolylineEdge {
  getEndArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    const pathAttr = {
      d: 'M 0 0 L 10 -5 L 10 5 Z',
      fill: '#fff',
      stroke: stroke || '#1890ff',
      strokeWidth: 1,
    };
    return h('path', pathAttr);
  }

  getStartArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    return h('circle', {
      cx: 0,
      cy: 0,
      r: 4,
      fill: '#fff',
      stroke: stroke || '#1890ff',
      strokeWidth: 1,
    });
  }
}

class MessageFlowModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, draggable: true };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'messageFlow');
    style.stroke = t.stroke || '#1890ff';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.strokeDasharray = '6,4';
    return style;
  }

  getTextStyle() {
    const style = super.getTextStyle();
    const t = getThemeStyle(this.graphModel, 'text');
    if (t && t.fill) style.color = t.fill;
    if (style.background) style.background = { fill: 'transparent' };
    return style;
  }

  // Prevent NaN text coordinates when edge points are not yet computed
  getTextPosition() {
    const pos = super.getTextPosition();
    if (isNaN(pos.x) || isNaN(pos.y)) {
      return { x: 0, y: 0 };
    }
    return pos;
  }
}

export const MessageFlow = {
  type: 'epx:MessageFlow',
  view: MessageFlowView,
  model: MessageFlowModel,
};
